"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreCampaignsInnerToJSON = exports.StoreCampaignsInnerFromJSONTyped = exports.StoreCampaignsInnerFromJSON = exports.instanceOfStoreCampaignsInner = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the StoreCampaignsInner interface.
 */
function instanceOfStoreCampaignsInner(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfStoreCampaignsInner = instanceOfStoreCampaignsInner;
function StoreCampaignsInnerFromJSON(json) {
    return StoreCampaignsInnerFromJSONTyped(json, false);
}
exports.StoreCampaignsInnerFromJSON = StoreCampaignsInnerFromJSON;
function StoreCampaignsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'closesAt': !(0, runtime_1.exists)(json, 'closes_at') ? undefined : json['closes_at'],
        'totalItemsQuantity': !(0, runtime_1.exists)(json, 'total_items_quantity') ? undefined : json['total_items_quantity'],
        'expectedQuantity': !(0, runtime_1.exists)(json, 'expected_quantity') ? undefined : json['expected_quantity'],
        'createdAt': !(0, runtime_1.exists)(json, 'created_at') ? undefined : json['created_at'],
        'placedAt': !(0, runtime_1.exists)(json, 'placed_at') ? undefined : json['placed_at'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : json['status'],
        'replacement': !(0, runtime_1.exists)(json, 'replacement') ? undefined : json['replacement'],
        'reopenable': !(0, runtime_1.exists)(json, 'reopenable') ? undefined : json['reopenable'],
        'closingSoon': !(0, runtime_1.exists)(json, 'closing_soon') ? undefined : json['closing_soon'],
        'timeRemainingInWords': !(0, runtime_1.exists)(json, 'time_remaining_in_words') ? undefined : json['time_remaining_in_words'],
    };
}
exports.StoreCampaignsInnerFromJSONTyped = StoreCampaignsInnerFromJSONTyped;
function StoreCampaignsInnerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'id': value.id,
        'closes_at': value.closesAt,
        'total_items_quantity': value.totalItemsQuantity,
        'expected_quantity': value.expectedQuantity,
        'created_at': value.createdAt,
        'placed_at': value.placedAt,
        'status': value.status,
        'replacement': value.replacement,
        'reopenable': value.reopenable,
        'closing_soon': value.closingSoon,
        'time_remaining_in_words': value.timeRemainingInWords,
    };
}
exports.StoreCampaignsInnerToJSON = StoreCampaignsInnerToJSON;
